// create an instance for nameSpace which contains keys as values, to simplify accessibility to nameSpaces
// this variable is used everywhere when we need to call a translation from a specific nameSpace.
// nameSpaces is an instance of Record <NameSpace, NameSpace>, dynamically generated from the set of declared modules,
// in order to obtain an object generated and shared from the loaded resource
import { nameSpaceNames } from './nameSpaceNames';

import type { NameSpace } from './locales.types';

export const nameSpaces: Record<NameSpace, NameSpace> = Object.fromEntries(
  nameSpaceNames.map(ns => [ns, ns]),
) as Record<NameSpace, NameSpace>;
